"use client";

import { Employer, GovernmentEmployerLocationRegistrationDto } from "@entities/employer";
import { GovernmentEmployerLocationDetails, GovernmentEmployerLocationRegistrationForm } from "@features/registration";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

function EditDialog({
  payload,
  onSubmit,
}: {
  payload?: GovernmentEmployerLocationRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerLocationRegistrationDto) => void;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = (data: GovernmentEmployerLocationRegistrationDto) => {
    if (onSubmit) {
      setIsOpen(false);
      onSubmit(data);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link">
          Ubah
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit alamat entitas</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <GovernmentEmployerLocationRegistrationForm formValue={payload || undefined} onSubmit={handleSubmit}>
            <div className="sticky bottom-0 grid grid-cols-2 gap-3 bg-white py-6">
              <DialogClose asChild>
                <Button className="text-sm font-bold" variant="outline">
                  Batal
                </Button>
              </DialogClose>
              <Button className="text-sm font-bold" variant="default">
                Simpan
              </Button>
            </div>
          </GovernmentEmployerLocationRegistrationForm>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function GovernmentEmployerLocationRegistrationPreview({
  location,
  onSubmit,
}: {
  location?: GovernmentEmployerLocationRegistrationDto | null;
  onSubmit?: (payload: GovernmentEmployerLocationRegistrationDto) => void;
}) {
  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Alamat entitas</h4>
        <EditDialog payload={location} onSubmit={onSubmit} />
      </div>
      <GovernmentEmployerLocationDetails
        employer={
          {
            village: {
              id: location?.village_id?.value,
              name: location?.village_id?.label,
              sub_district: {
                id: location?.sub_district_id?.value,
                name: location?.sub_district_id?.label,
                city: {
                  id: location?.city_id?.value,
                  name: location?.city_id?.label,
                  province: {
                    id: location?.province_id?.value,
                    name: location?.province_id?.label,
                  },
                },
              },
            },
            postalCode: location?.postal_code,
            address: location?.address,
          } as Employer
        }
      />
    </div>
  );
}
